import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { FiItemCategoryImportFileHdrContainer } from '../../../../../../models/aggregates/erp/fi-item-category/fi-item-category-import-file-hdr-container.model';
import { ApiVisa } from '../../shared/api-visa.model';
@Injectable({ providedIn: 'root' })
export class FinancialItemCategoryImportFileService extends BaseApiTemplateService<FiItemCategoryImportFileHdrContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-label-import-file-hdrs/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-label-import-file-hdrs/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'item-label-import-file-hdrs/backoffice-ep';
    this.httpClient = http;
  }

  public uploadImportFile(formData: FormData, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '?delimiter=COMMA';
    return this.httpClient.post(url, formData, this.getHttpHeader(visa));
  }

}